<template>
    <slot />
</template>

<script>
    export default {
        name: 'LayoutAuth'
    }
</script>
